import { render, staticRenderFns } from "./TraitsForm.vue?vue&type=template&id=0391aff4&scoped=true&"
import script from "./TraitsForm.vue?vue&type=script&lang=js&"
export * from "./TraitsForm.vue?vue&type=script&lang=js&"
import style0 from "./TraitsForm.vue?vue&type=style&index=0&id=0391aff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0391aff4",
  null
  
)

export default component.exports